import { IOptions } from "@/core/@types/types";
import Result from "@/core/common/Result";

export interface IUsuarioPorEmpresaUseCase {
  createList(empresaId: (string | undefined)[]): Promise<Result<IOptions[]>>;
}

export const usuariosPorEmpresaUseCaseDI = Symbol(
  "usuariosPorEmpresaUseCaseDI"
);
